var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamdomTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 316.6,
    height: 400.527,
    viewBox: "0 0 316.6 400.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tower",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GAMDOM_LOGO",
    "data-name": "GAMDOM LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M106.491,15.792,8.085,62.629a8.646,8.646,0,0,0-4.8,7.772v90.952a8.589,8.589,0,0,0,4.8,7.772l98.456,46.889a18.216,18.216,0,0,0,7.931,1.786V13.954A20.354,20.354,0,0,0,106.491,15.792Z",
    transform: "translate(43.827 182.697)",
    fill: "#00ff86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M153.92,1.384l-46.176,23v61.8L53.689,112.86V50.532L5.269,74.738A9.554,9.554,0,0,0,0,83.246V202.337a9.437,9.437,0,0,0,13.566,8.5L149.9,143.524a18.94,18.94,0,0,1,8.4-1.943V.333A9.8,9.8,0,0,0,153.92,1.384Z",
    transform: "translate(0 -0.333)",
    fill: "#00ff86"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_32",
    "data-name": "Union 32",
    d: "M0,196.654a17.215,17.215,0,0,1,7.986,1.784l98.456,46.841a8.667,8.667,0,0,1,4.8,7.823v90.947a8.646,8.646,0,0,1-4.8,7.77L8.035,398.71A18.691,18.691,0,0,1,0,400.5ZM144.736,210.51,8.4,143.192A19.722,19.722,0,0,0,0,141.25V0A9.98,9.98,0,0,1,4.384,1.048l46.174,23v61.8l54.108,26.671V50.145l48.419,24.206A9.428,9.428,0,0,1,158.3,82.91V202a9.474,9.474,0,0,1-9.427,9.488A9.3,9.3,0,0,1,144.736,210.51Z",
    transform: "translate(158.298 0.031)",
    fill: "#01d370"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamdomTower);
export default __webpack_public_path__ + "static/media/gamdom_tower.edf96bed4649d6aaa1ac5249a0a6ceb4.svg";
export { ForwardRef as ReactComponent };